import React from 'react';
import Input from '../../../../shared/components/Input';
import { IInput } from '../../../../shared/interfaces/inputs';

function PasswordInput(props: IInput) {
  return <Input.Default onChange={props.onChange} type="password" />;
}

export default PasswordInput;
